<template>
  <div class="wrapper">
  <div class="features-1">
     
   
  <div class="row">
    <div class="col-md-8 ml-auto mr-auto text-center">
      <h2 class="title">Teléfonos Útiles</h2>
    </div>
  </div>
  </div>

  <div class="card">

    <div class="card-body row">
      <div class="col-12">
        <el-table 
            :data="tableData"
            header-row-class-name="text-primary"
            v-show="!isMobile()"
          >
          
            <el-table-column prop="Descripcion" label="Descripción" min-width="350px"></el-table-column>
           
            <el-table-column prop="Telefono" min-width="200px" label="Teléfono">
               <template slot-scope="scope">
                 <ul style="list-style: none;">
                    <li v-for="item in scope.row.Telefonos" :key="item.Descripcion">
                      {{ item }}
                    </li>
                 </ul>
              </template>
            </el-table-column>
           
            <el-table-column prop="Ubicacion" min-width="200px" label="Ubicación"></el-table-column>
        </el-table>
        <el-table 
            :data="tableData"
            header-row-class-name="text-primary"
            v-show="isMobile()"
          >
          
            <el-table-column prop="Descripcion" label="">
              <template slot-scope="scope">
                <p>
                  <b>{{ scope.row.Descripcion }}</b>
                </p>
                <p>
                  <span style="display:block;" v-for="item in scope.row.Telefonos" :key="item.Descripcion">
                    <i class="now-ui-icons tech_mobile"></i>   {{  item }}
                  </span>
                </p> 
                <p>
                  <b> <i class="now-ui-icons location_pin"></i> {{  scope.row.Ubicacion }}</b>
                </p>

              </template>
            </el-table-column>
        </el-table>
      </div>
    </div>
  </div>

</div>
</template>
<script>
import { Button, InfoSection, FormGroupInput,Card } from "@/components";
import { API_KEY } from "@/constants";
import Vue from "vue";
import { Table, TableColumn } from "element-ui";


Vue.use(Table);
Vue.use(TableColumn);

export default {
  name: "home",
  bodyClass: "home",
  components: {
    InfoSection,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
    data() {
    return {     
        tableData:[]
       
    };
  },
   async created() {
      let res = await this.$osapm().get("misc/getTelefonosUtiles");

      this.tableData = res.data;
      }
};
  
</script>
<style scoped>
.telefonos {
  color: black;
}
</style>
